import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {Loader as ContentLoader} from '../../../../shared/library/loaders/loader';
import {MobileContext} from '../../../../shared/enhancers/mobile-enhancer';

const loaderLength = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];

const Loader = ({gridCols = 2, elementsLength = 4, dataKey}) => {
  const isMobile = useContext(MobileContext);
  const getHeightWidth = () => {
    let height = 318,
      width = '100%';

    if (gridCols === 3) {
      height = 200;
    } else if (gridCols === 9 || dataKey === 'team') height = 60;

    if (dataKey === 'followers' && isMobile) {
      height = 64;
      width = 64;
    }

    return {
      width: width,
      height: height
    };
  };

  return (
    <>
      {loaderLength.slice(0, elementsLength).map(i => (
        <ContentLoader
          w={getHeightWidth().width}
          h={getHeightWidth().height}
          style={{margin: '0 15px 0 0'}}
          animate={true}
          key={i}
        />
      ))}
    </>
  );
};

Loader.propTypes = {
  elementsLength: PropTypes.number,
  gridCols: PropTypes.number,
  dataKey: PropTypes.string
};

export default Loader;
